import { axios } from './config';

export const registerGamVersion = (key, value) => {
	return axios.post('/gam/custom-targeting-values', { key, value });
};
